import NrwSingleLayoutComponents from '~pages/nrw/layouts/NrwSingleLayoutComponents.js'

// import AttendAuth from '~pages/nrw/attend/AttendAuth.vue'
import AttendTimeCheck from '~pages/nrw/attend/AttendTimeCheck.vue'
import AttendJoin from '~pages/nrw/attend/AttendJoin.vue'
import AttendMainAuth from '~pages/nrw/attend/AttendMain.vue'
let routeInfo = [
  {
    path: 'attendAuth',
    name: 'AttendAuth',
    components: Object.assign({}, NrwSingleLayoutComponents, { content: AttendMainAuth }),
    beforeEnter: (to, from, next) => {
      if (Object.keys(to.query).length > 0) {
        next()
      } else {
        next('/error')
      }
    },
    props: true,
    meta: {
      authorized: false
    }
  },

  {
    path: 'attendTimeCheck',
    name: 'AttendTimeCheck',
    components: Object.assign({}, NrwSingleLayoutComponents, { content: AttendTimeCheck }),
    beforeEnter: (to, from, next) => {
      // console.log('CheckAttendTime root beforeEnter', to, from)
      if (Object.keys(to.query).length > 0) {
        next()
      } else {
        next('/error')
      }
    },
    props: true,
    meta: {
      authorized: false
    }
  },

  {
    path: 'attendJoin',
    name: 'AttendJoin',
    components: Object.assign({}, NrwSingleLayoutComponents, { content: AttendJoin }),
    beforeEnter: (to, from, next) => {
      // console.log('CheckAttendTime root beforeEnter', to, from)
      if (Object.keys(to.query).length > 0 || Object.keys(to.params).length > 0) {
        next()
      } else {
        next('/error')
      }
    },
    props: true,
    meta: {
      authorized: false
    }
  },
  {
    path: 'error',
    name: 'error',
    components: Object.assign({}, NrwSingleLayoutComponents, {
      content: () => import(/* webpackChunkName: "page_error" */ '~pages/nrw/error/PageNotFound.vue') }
    ),
    meta: {
      authorized: false
    }
  }
]

export default routeInfo



// WEBPACK FOOTER //
// ./src/config/router/nrw/child/attendRouter.js